<template>
  <el-dialog
    class="dialog-container"
    :title="$t('request.tips')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="false"
    :close-on-press-escape="false"
    width="420px"
    append-to-body
  >
    <div style="text-align: center; width: 100%">
      <i
        class="el-icon-warning-outline"
        style="color: #e99d42; margin-right: 13px"
      />{{ completeTip }}
    </div>
    <div slot="footer" class="dialog-footer">
      <!-- <el-button
        :loading="nextLoading"
        type="primary"
        size="mini"
        @click="getNextData"
        >下一条</el-button
      > -->
      <el-button class="primary-btn" type="primary" size="mini" @click="back">{{
        $t("operate.backList")
      }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
// import { getNextDataFun } from "@/util/index";
// import { problemListApi } from "@/api/feedback";

export default {
  components: {},
  data() {
    return {
      title: "", // 弹窗标题
      completeTip: "", // 完成提示
      dialogVisible: false,
      nextLoading: false,
    };
  },
  mounted() {},
  methods: {
    // 初始化
    async init(completeTip) {
      this.completeTip = completeTip;
      this.dialogVisible = true;
    },
    // 返回
    back() {
      this.$router.go(-1);
    },
    // // 下一条
    // async getNextData() {
    //   this.nextLoading = true;
    //   const taskStatus = this.$route.query?.searchObj?.taskStatus;
    //   await getNextDataFun(
    //     this,
    //     problemListApi,
    //     taskStatus !== 0 ? "next" : ""
    //   );
    //   this.nextLoading = false;
    // },
  },
};
</script>

<style lang="scss" scoped>
.dialog-container {
  ::v-deep .el-dialog {
    // border-radius: 5px;
    .el-dialog__header {
      // height: 47px;
      // padding: 0 12px 0 28px;
      // border-bottom: 1px solid #efefef;
      // border-radius: 5px 5px 0 0;
      // display: flex;
      // justify-content: space-between;
      // align-items: center;

      .el-dialog__title {
        // color: #333333;
        // font-size: 18px;
      }

      .el-dialog__headerbtn {
        // position: unset;
        // font-size: 22px;
      }
    }
    .el-dialog__footer {
      // text-align: center;
      // border-top: 1px solid #efefef;
      // padding: 20px 20px 26px 20px;
    }
  }
}
</style>
